'use client'

import { memo } from 'react'
import { EvervaultCard, EvervaultCornerIcon } from '@/components/ui/evervault-card'
import { cn } from '@/lib/utils'

/** Evervault cipher field: hover anywhere to animate (no card chrome). */
export const NinPrivacyVault = memo(function NinPrivacyVault({
  className,
}: {
  className?: string
}) {
  return (
    <div
      className={cn(
        'nin-privacy-cipher relative mx-auto h-[22rem] w-full max-w-xl overflow-hidden md:h-[26rem]',
        className,
      )}
    >
      <EvervaultCornerIcon className="absolute left-2 top-2 z-20 h-5 w-5 text-[color:var(--ninxl-theme-fg)] opacity-70" />
      <EvervaultCornerIcon className="absolute bottom-2 right-2 z-20 h-5 w-5 text-[color:var(--ninxl-theme-fg)] opacity-70" />

      <EvervaultCard
        text="NIN"
        size="lg"
        className="absolute inset-0 h-full w-full"
        roundedClassName="rounded-xl"
      >
        <p className="text-sm font-light text-[color:var(--ninxl-theme-fg-muted)]">
          Hover to reveal the cipher field
        </p>
      </EvervaultCard>
    </div>
  )
})
